<style>
</style>

<template>
<div id="logout--view">
  <v-container grid-list-xs>
    <v-row mt-3 mb-3>
      <v-col xs="12" class="text-center">
        <v-dialog v-model="logoutDialog" width="600px">
          <v-card>
            <v-card-title>{{ $t('Odhlášení') }}</v-card-title>
            <v-card-text class="background: secondary">
              <div>{{ $t('Byli jste odhlášení z klientské zóny. Můžete pokračovat jako ') }}
                <a @click="toEshop">{{ $t('neregistrovaný uživatel') }}</a>{{ $t(' nebo se opět ') }}
                <a @click="signIn">{{ $t('přihlásit') }}</a>{{ '.' }}
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import StorageMixin from '@/mixins/storage-mixin.js'
const kzona = require('@/oauth2/kzona.json')
const eshop = require('@/oauth2/eshop.json')
import {
  eventBus
} from '@/main'

export default {
  name: 'LogoutPage',
  mixins: [StorageMixin],
  data() {
    return {
      logoutDialog: false
    }
  },
  mounted() {
    // window.postMessage({
    //   'event': 'logout-dialog-message'
    // }, '*')
    eventBus.$emit('logout-dialog-message')

    this.logoutDialog = true
    this.setRegistered(false)
    this.setRoute()
    this.setBasket()
    this.$oauth2.storage.removeValue('chip-route-name', this.institutionId, this.customerId)
    const oauth2 = !this.isRegistered ? eshop : kzona
    const env = oauth2[process.env.NODE_ENV] ? oauth2[process.env.NODE_ENV] : oauth2
    var value = {
      path: env['authPath']
    }
    if (env['authPort']) {
      value['domain'] = this.$oauth2.getHost() + ':' + env['authPort']
    }
    this.$oauth2.removeRefreshToken(value)
    this.$oauth2.removeAccessToken()
    this.$customer.customer = {}
    this.$customer.customerData.cards = []
    this.$customer.customerData.documents = []
    this.$customer.customerData.reservations = []
    this.$customer.customerData.visits = []
    this.$customer.customerData.orders = []
    this.$customer.customerData.gdprStates = []
    // this.$institution.institution = {}
    this.$basket.basket = {}
  },
  watch: {
    logoutDialog(value) {
      if (!value) {
        this.$router.push({
          name: 'home'
        }).catch(console.log)
      }
    }
  },
  beforeDestroy() {
    this.logoutDialog = false
  }
}
</script>
